import React from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import PropTypes from "prop-types";

export default function HeroAccount({ heroHeadingType, heroHeadingBody, heroBody, backgroundColor, backgroundImage, id }) {
  let heroStyle = {};
  if (backgroundColor) {
    heroStyle = { backgroundColor: backgroundColor.fields.phrase.value };
  }
  if (backgroundImage.value?.src) {
    heroStyle = {
      backgroundImage: `url(${backgroundImage.value.src}), linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5) )`
    };
  }

  return (
    <div className="grid hero-account" style={heroStyle} id={id}>
      <Heading type={heroHeadingType} className="title show-on-scroll" html={heroHeadingBody} typographyClass="type-h1" />

      {heroBody && (
        <div
          className="body-text"
          dangerouslySetInnerHTML={{
            __html: heroBody.value
          }}
        />
      )}
    </div>
  );
}

HeroAccount.propTypes = {
  heroHeadingType: PropTypes.object,
  heroHeadingBody: PropTypes.object,
  heroBody: PropTypes.shape({ value: PropTypes.string }),
  backgroundColor: PropTypes.shape({
    fields: PropTypes.shape({
      phrase: PropTypes.shape({ value: PropTypes.string })
    })
  }),
  backgroundImage: PropTypes.shape({
    value: PropTypes.shape({ src: PropTypes.string })
  }),
  id: PropTypes.string
};
